import styled from 'styled-components';

const FloatingTabsStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  scrollBarWidth: 'none',
  boxSizing: 'border-box',
  overflowX: 'auto',
  '::-webkit-scrollbar': {
    display: 'none',
  },
});

export { FloatingTabsStyled };
